import React from 'react';
import { useHistory } from 'react-router-dom';
import { iconArrowLeft } from '../../assets/icons';

import { Container } from './styles';

interface tabNavItens {
  title?: string;
  path?: string; 
  backTab?: () => void
}

export const GoToBack: React.FC<tabNavItens> = ({title = "Voltar", path, backTab}) => {
  const {push, goBack} = useHistory();
  return (
    <Container>
      <button onClick={backTab ? () => backTab() : path ? () => push(path) : () => goBack()}>
        {iconArrowLeft}
        <span>{title}</span>
      </button>
    </Container>
  );
}